import { Injectable, OnInit } from '@angular/core';
import { CanLoad, Router, CanActivate } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectGuard implements OnInit, CanLoad, CanActivate {

  private IsAuth:boolean;

  constructor
    (
      private _auth: AuthService,
      private _router: Router,
  ){ 
  }

  ngOnInit():void{
  }

  canLoad(){
    if (this._auth.isAuthenticate()){
      this._router.navigateByUrl("/home")
      /* var actualRoute = window.location.origin+'/home';
      window.location.replace(actualRoute); */
    }else{
      return true
    }
  }

  canActivate(){
    if (this._auth.isAuthenticate()){
      this._router.navigateByUrl("/home")
    }else{
      return true
    }
  }

}
